import { render, staticRenderFns } from "./TransactionConfirmCell.vue?vue&type=template&id=71f9e8b3&"
import script from "./TransactionConfirmCell.vue?vue&type=script&lang=babel&"
export * from "./TransactionConfirmCell.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports